import { useState } from "react";

import { PageHeader } from "@/components/PageHeader";
import { Button } from "@/components/ui/button";
import { useImageUpload } from "@/hooks/use-image-upload";
import { generateImageUrl } from "@/utils/image";

export const UploadGfxRoute = () => {
    const [imageId, setImageId] = useState<string | null>(null);
    const url = generateImageUrl({ imageId, width: 1080, height: 1920 });

    const { startSelectFile, inputProps, isUploading } = useImageUpload({
        onUploadFinished: imageId => {
            setImageId(imageId);
        },
    });

    return (
        <div className="m-4 flex flex-col items-start gap-4">
            <PageHeader title="Upload image for studio graphics" />
            <input {...inputProps} />
            <Button variant="default" onClick={() => startSelectFile()} disabled={isUploading}>
                {isUploading ? "Uploading..." : "Upload image"}
            </Button>

            {imageId && (
                <div>
                    <div>
                        Copy one of the buttons from{" "}
                        <a href="http://192.168.231.99:8000/buttons/6">here</a> and set the image
                        url to, use the following as imageUrl
                    </div>
                    <pre>{url}</pre>
                    <img src={url} />
                </div>
            )}
        </div>
    );
};
